<ds-modal
  #languageSettingsModal
  [ds-modal-trigger-for]="languageSettingsModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '585px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header size="md">{{ 'header.languageSettingsModal.title' | translate }}</ds-box-header>

  <ds-box-content id="change-language-modal">
    <form [ds-form]="reactiveForm" [formGroup]="reactiveForm" id="search-language-form">
      <ds-form-field>
        <input
          ds-input
          ds-autosuggest
          ds-form-validation
          required
          formControlName="languageToSearch"
          placeholder="{{ 'header.languageSettingsModal.searchPlaceholder' | translate }}"
          [minCharsToFilter]="3"
          [showNoResultsMessage]="false"
          (keyup)="searchLanguage()"
          id="search-language-input"
        />

        @if (reactiveForm.controls['languageToSearch'].value) {
        <ds-button ds-button icon="close" variant="ghost-muted" (click)="clearSelectedLanguage()"></ds-button>
        }
        <ds-icon icon="search" />
      </ds-form-field>
    </form>

    @if(this.languageOptions) {
    <div class="w-100 d-flex flex-row flex-wrap align-items-center" id="language-options-container">
      @for (language of this.languageOptions; track $index) {

      <div
        [ngClass]="{
            'mx-2x': $index % 3 === 1
          }"
      >
        <button
          class="language-button mt-2x"
          ds-toggle-button
          [checked]="language.isActive"
          [disabled]="language.isActive"
          (click)="onSelectLanguage(language, true)"
          [id]="language.isActive ? 'active-language-button' : 'inactive-language-button'"
        >
          {{ language.name | translate }}
        </button>
      </div>

      }
    </div>
    } @else {
    <div class="w-100 d-flex flex-row flex-wrap align-items-center">
      <span>{{ 'header.languageSettingsModal.noItems' | translate }}</span>
    </div>
    }
  </ds-box-content>

  <ds-box-footer>
    <button #dsModalDismissElement ds-button class="me-2x" id="btn-cancel-modal" variant="outline">
      {{ 'common.buttons.cancel' | translate }}
    </button>

    <ds-button
      class="ms-2x"
      icon="translate"
      [disabled]="!languageChanged()"
      (click)="onChangeLanguage()"
      id="save-language-button"
    >
      {{ 'header.languageSettingsModal.title' | translate }}
    </ds-button>
  </ds-box-footer>
</ds-modal>
